import { useCallback } from "react"
import { useLocation } from "react-router-dom"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"

interface ButtonClickData {
  name: string
  href?: string
  [key: string]: unknown
}

export function useButtonClickTracking() {
  const { pathname } = useLocation()
  const { mutate: addMemberAction } = useMemberActionTracking()

  const trackButtonClick = useCallback(
    ({ name, href, ...rest }: ButtonClickData) => {
      addMemberAction({
        memberActionTaken: MemberActions.BUTTON_CLICKED,
        metaData: { path: pathname, name, ...(href !== undefined ? { href } : {}), ...rest }
      })
    },
    [pathname, addMemberAction]
  )

  return { trackButtonClick }
}
